import React from 'react';
import { IconTooltip } from 'utils/components/IconTooltip';
import DarkVenueHeatmapHelpText from 'widgets/darkVenueHeatmap/DarkVenueHeatmapHelpText.tsx';

export default function DarkVenueHeatmapHelp() {
    return (
        <IconTooltip>
            <DarkVenueHeatmapHelpText />
        </IconTooltip>
    );
}
